import { Box } from '@mui/material';
import YourDataTab from './YourDataTab';

// Full-height wrapper for YourData tab — sits outside scroll container
export default function DashboardYourData({ height }) {
    return (
        <Box
            sx={{
                height: height || '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                background: 'var(--j-canvas)',
            }}
        >
            <YourDataTab sx={{ height: '100%' }} />
        </Box>
    );
}
